if(typeof BSS_B2B != undefined) {
  window.addEventListener("cart_changed", () => {
    setTimeout(() => {
      let storeData = JSON.parse($("#bss-b2b-store-data").html());
      BSS_B2B.makeChangesAfterClickAjaxCart(500)
      BSS_B2B.cart.fixer(storeData, null, false);
      BSS_B2B.handleCartCheckoutBtn(storeData);
    }, 500);
  });

//fix spam checkout 
  setTimeout(() =>{
    function handleButtonClick(e) {
      if(BSS_B2B?.cart?.updatedLineItems?.length) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
      }  
    }
   
   $(document).on('click dblclick', 'button[name="checkout"]', handleButtonClick);
  }, 500)

BSS_B2B.customTriggerCheckoutBtn = function(checkoutBtn){
    window.location.href = "/checkout";
  }
  
}